<div class="tpl3pl-throughput-series">
	<div class="tpl3pl-throughput-series__toolbar d-flex align-items-center flex-wrap mb-2">
		<button
			type="button"
			class="btn btn-success btn-sm mr-1"
			(click)="exportXlsx()"
			[disabled]="!series?.length"
			title="Export XLSX"
		>
			<i class="fa fa-file-excel-o"></i> XLS
		</button>
		<button
			type="button"
			class="btn btn-danger btn-sm"
			(click)="exportPdf()"
			[disabled]="!series?.length || pdfExporting"
			title="Export PDF"
		>
			<i class="fa fa-file-pdf-o"></i> PDF
		</button>
	</div>

	<div #printTable class="tpl3pl-throughput-series__print">
		<p class="tpl3pl-throughput-series__print-head small mb-1" *ngIf="reportTitle || dateRangeLabel">
			<strong *ngIf="reportTitle">{{ reportTitle }}</strong>
			<span *ngIf="reportTitle && dateRangeLabel"><br /></span>
			<span class="text-muted" *ngIf="dateRangeLabel">{{ dateRangeLabel }}</span>
		</p>
		<p class="tpl3pl-throughput-series__print-summary small text-muted mb-2" *ngIf="series?.length">
			Total <strong>{{ seriesTotal | number:'1.0-0' }}</strong>
			· {{ seriesDayCount }} day(s)
			· Avg / day <strong>{{ seriesAvgPerDay | number:'1.0-2' }}</strong>
		</p>
		<div class="table-responsive tpl3pl-throughput-series__scroll">
			<table class="table table-sm table-striped mb-0 tpl3pl-throughput-series__table">
				<thead>
					<tr>
						<th>Date</th>
						<th class="text-right">{{ columnLabel() }}</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of series">
						<td>{{ row.date }}</td>
						<td class="text-right">{{ valueFor(row) }}</td>
					</tr>
				</tbody>
				<tfoot *ngIf="series?.length" class="tpl3pl-throughput-series__tfoot">
					<tr>
						<th scope="row">Total</th>
						<th class="text-right">{{ seriesTotal | number:'1.0-0' }}</th>
					</tr>
					<tr>
						<th scope="row">Avg / day</th>
						<th class="text-right">{{ seriesAvgPerDay | number:'1.0-2' }}</th>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
</div>
